import type { FunctionComponent } from 'react';

import { Pill } from 'components/admin';

import type { RoleT } from 'utils';

import './style.scss';

type PropsT = {
  roles: RoleT[];
};

export const UserRoles: FunctionComponent<PropsT> = ({
  roles,
}) => (
  <div styleName="container">
    {roles.includes('OWNER_INACTIVE')
      ? <Pill kind="grey">Inactive Admin</Pill> : null}
    {roles.includes('OWNER')
      ? <Pill kind="red">Admin</Pill> : null}
    {roles.includes('ARTIST')
      ? <Pill kind="green">Practitioner</Pill> : null}
    {roles.includes('ARTIST_INACTIVE')
      ? <Pill kind="grey">Inactive Practitioner</Pill> : null}
    {roles.includes('PRACTITIONER_APPLICANT')
      ? <Pill kind="red">Pracitioner Applicant</Pill> : null}
    {roles.includes('BETA_TESTER')
      ? <Pill kind="blue">Beta Tester</Pill> : null}
  </div>
);
